<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div class="task-screen-element fill-in-blank-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()" [disabled]="disableAVButtons"></button>
    </div>
    <div class="make-the-image-main-container">
      <div class="make-the-image-container" [hidden]="!currentWordImage">
        @if (currentWordImage) {
          <img
            [src]="currentWordImage"
            [alt]="'Image for word'"
            class="make-the-image"
            (error)="currentWordImage = null">
        }
      </div>
      <div class="word-to-complete-unit">
        <div class="audio-controls-container">
          <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons"></button>
          <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed()" [disabled]="disableAVButtons"></button>
        </div>
        <div class="make-the-target-row">
          @for (letter of targetWord; track $index) {
            <div class="make-the-response-target-block stw-target intervention-target-block"
              [class.hover]="($index===blankTile)"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '">
              @if (!oneIncorrectAnswer) {
                <button class = "make-the-target-letter-audio-hidden"></button>
              }
              @if (oneIncorrectAnswer) {
                <button class = "make-the-target-letter-audio"
                (click)="playTargetLetterAudio($index)" [disabled]="disableAVButtons"></button>
              }
              <button class="make-the-target-text font-30">
                {{letter.text}}
              </button>
              <button [class]="{'make-the-remove-letter-disabled': letter.disabled, 'make-the-remove-letter': !letter.disabled, 'make-the-remove-letter-disabled-hover': ($index===blankTile)}"
              (click)="removeLetter($index)" [disabled]="letter.disabled"></button>
            </div>
          }
        </div>
        @if (!hideSubmitButton) {
          <button (click)="submitResponse()" [class]="(disableSubmitButton) ? 'star-submit-disabled' : 'star-submit'"
          [disabled]="disableSubmitButton" ></button>
        }
      </div>
    </div>
    <div class="make-the-response-row">
      @for (response of responseOptions1; track response.index) {
        <div [class]="(makeThePhrase) ? 'make-the-phrase-big-button-div' : 'big-button-div'"
          >
          @if (!showResponseAudioButtons) {
            <button [class]="(makeThePhrase) ? 'make-the-phrase-big-div-letter-audio-hidden' : 'big-div-letter-audio-hidden'"
            ></button>
          }
          @if (showResponseAudioButtons) {
            <button [class]="(makeThePhrase) ? 'make-the-phrase-big-div-letter-audio' : 'big-div-letter-audio'"
            (click)="playLetterAudio(response.audio)" [disabled]="disableAVButtons"></button>
          }
          <button #resp1Button [class]="(makeThePhrase) ? 'make-the-phrase-response-block' : 'make-the-response-block'"
            class = "font-30"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="responsesDisabled" (click)="addLetter(response.index); removeHoverClass(resp1Button);"
            (mouseenter)="addHoverClass(resp1Button)" (mouseleave)="removeHoverClass(resp1Button)"
            (touchstart)="addHoverClass(resp1Button)" (touchend)="removeHoverClass(resp1Button)">
            {{response.text}}
          </button>
        </div>
      }
    </div>
    <div class="make-the-response-row">
      @for (response of responseOptions2; track response.index) {
        <div [class]="(makeThePhrase) ? 'make-the-phrase-big-button-div' : 'big-button-div'"
          >
          @if (!showResponseAudioButtons) {
            <button [class]="(makeThePhrase) ? 'make-the-phrase-big-div-letter-audio-hidden' : 'big-div-letter-audio-hidden'"
            ></button>
          }
          @if (showResponseAudioButtons) {
            <button [class]="(makeThePhrase) ? 'make-the-phrase-big-div-letter-audio' : 'big-div-letter-audio'"
            (click)="playLetterAudio(response.audio)" [disabled]="disableAVButtons"></button>
          }
          <button #resp2Button [class]="(makeThePhrase) ? 'make-the-phrase-response-block' : 'make-the-response-block'"
            class = "font-30"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="responsesDisabled" (click)="addLetter(response.index); removeHoverClass(resp2Button)"
            (mouseenter)="addHoverClass(resp2Button)" (mouseleave)="removeHoverClass(resp2Button)"
            (touchstart)="addHoverClass(resp2Button)" (touchend)="removeHoverClass(resp2Button)">
            {{response.text}}
          </button>
        </div>
      }
    </div>
    <div class="make-the-response-row">
      @for (response of responseOptions3; track response.index) {
        <div [class]="(makeThePhrase) ? 'make-the-phrase-big-button-div' : 'big-button-div'"
          [hidden]="!showResponseOptions3">
          @if (!showResponseAudioButtons) {
            <button [class]="(makeThePhrase) ? 'make-the-phrase-big-div-letter-audio-hidden' : 'big-div-letter-audio-hidden'"
            ></button>
          }
          @if (showResponseAudioButtons) {
            <button [class]="(makeThePhrase) ? 'make-the-phrase-big-div-letter-audio' : 'big-div-letter-audio'"
            (click)="playLetterAudio(response.audio)" [disabled]="disableAVButtons"></button>
          }
          <button #resp3Button [class]="(makeThePhrase) ? 'make-the-phrase-response-block' : 'make-the-response-block'"
            class = "font-30"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="responsesDisabled" (click)="addLetter(response.index); removeHoverClass(resp3Button)"
            (mouseenter)="addHoverClass(resp3Button)" (mouseleave)="removeHoverClass(resp3Button)"
            (touchstart)="addHoverClass(resp3Button)" (touchend)="removeHoverClass(resp3Button)">
            {{response.text}}
          </button>
        </div>
      }
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
